<template>
  <b-container class="custom-container px-0 py-5 mb-5">
    <div class="page-title pt-5">Edit Job</div>
    <b-card class="mt-4">
      <div class="mx-auto p-5 w-75">
        <div class="font-weight-bold mb-4 page-subtitle">Job Details</div>
        <job-form :job="job" v-if="job" />
      </div>
    </b-card>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import JobForm from '@/components/forms/JobForm'

export default {
  components: {
    JobForm
  },

  computed: {
    ...mapState({
      job: state => state.job.jobDetails
    })
  },

  methods: {
    ...mapActions({
      getJobDetails: 'job/getJobDetails'
    }),

    async fetchJob(page = 1) {
      if (this.loading) return
      this.loading = true
      await this.getJobDetails(this.$route.params.id)
      this.loading = false
    }
  },

  async created() {
    await this.fetchJob()
  }
}
</script>
